import { fmlmViewInformation } from "../../../app/api/fmlmSearchLocation";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFmlmView } from "../../../Orchestrator/Types/Interface/IFmlmView";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { FmlmViewOffersResponseMapType } from "../../../Flows/FmlmDetail/Context/FmlmViewContext";
import { DEFAULT_TIMEZONE } from "../../../config/global";
import { hideLoader, showLoader } from "../../../Lib/Utils/validationUtil";
import { IGetAllFmlmJourneyActionParams, IGetAllFmlmJourneyActionResponse } from "../../../Orchestrator/Types/Interface/ActionParams/GetAllFmlmJourneyActionParams";
dayjs.extend(utc);
dayjs.extend(timezone);

class GetAllFmlmJourneyAction extends BaseAction<IGetAllFmlmJourneyActionResponse | null, IGetAllFmlmJourneyActionParams> {
  override async run(): Promise<IGetAllFmlmJourneyActionResponse | null> {
    const { payload } = this.params!

    updateRecoilState("fetchingFmlmViewInformationAtom", true);

    const fmlmViewOffersMap: FmlmViewOffersResponseMapType = new Map();
    let fmlmViewList: IFmlmView[] = [];

    try {
      const startTime = dayjs(payload.departureTime).tz(DEFAULT_TIMEZONE).subtract(2, 'hours').valueOf();
      const endTime = dayjs(payload.departureTime).tz(DEFAULT_TIMEZONE).valueOf();

      let nextTime = startTime

      showLoader();

      do {
        const response = await fmlmViewInformation({
          ...payload,
          departureTime: nextTime,
        }, false);
        if (response?.answer?.success && response?.answer?.data?.outboundJourneys?.length > 0) {
          let list = response?.answer?.data?.outboundJourneys || []
          fmlmViewList = [...fmlmViewList, ...list]
          let nextJourneyTime = fmlmViewList[fmlmViewList.length - 1]?.departureTimestampPlanned || null
          if (nextJourneyTime) {
            nextTime = nextJourneyTime;
          } else {
            nextTime = dayjs(nextTime).tz(DEFAULT_TIMEZONE).add(2, 'hour').valueOf();
          }
        } else {
          nextTime = dayjs(nextTime).tz(DEFAULT_TIMEZONE).add(2, 'hour').valueOf();
        }
      } while (nextTime < endTime);

      let uniqueListFmlmOfferList = fmlmViewList.filter((offer, index, self) =>
        index === self.findIndex(obj =>
          obj?.attributes?.STABLE_JOURNEY_SEGMENT_ID === offer?.attributes?.STABLE_JOURNEY_SEGMENT_ID
        )
      );
      fmlmViewList = uniqueListFmlmOfferList;
    } catch (error) {
      console.error("Error in GetAllFmlmJourneyAction:", error);
      return null
    } finally {
      updateRecoilState("fetchingFmlmViewInformationAtom", false);
      updateRecoilState<IFmlmView[]>("allFmlmJourneyAtom", fmlmViewList || []);
      hideLoader();
      return {
        fmlmView: fmlmViewList,
        fmlmViewOffersMap: fmlmViewOffersMap
      }
    }
  }
}

export const getAllFmlmJourneyAction = new GetAllFmlmJourneyAction();
